import {Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';

@Component({
    selector: 'app-expandable-content',
    templateUrl: './expandable-content.component.html',
})
export class ExpandableContentComponent implements OnInit {
    @Input() title: string;
    @Input() expanded = false;
    @Input() contentPadding = false;
    @Output() expandedEvent = new EventEmitter<boolean>();

    // To benefit lazy rendering
    @ContentChild('expandedContent', { read: TemplateRef }) expandedContentTemplate?: TemplateRef<any>;


    constructor() {
    }

    ngOnInit() {
    }

    onExpanded() {
        this.expanded = !this.expanded;
        this.expandedEvent.emit(this.expanded);
    }

}
